module.exports = __webpack_public_path__ + "static/media/avatar-default.4cd0d714.png";